export default {
    areYouSure:
        '現在のアカウントデータを無料で保管することも可能です。また、メールの通知設定の見直しも可能です。',
    autoDeletionWarning:
        'ユーザーアカウントを削除すると下記の会社アカウントも削除されます。（会社アカウントを残す場合は、ほかの方を所有者としてご指定ください。）',
    billingDetails: 'プランの詳細',
    changeOwner: '（所有者を変更）',
    companies: '会社アカウント',
    deletingYourUser:
        'ユーザーアカウントを削除すると、次の項目も削除されます。以下の会社（他の人をオーナーに設定する場合 自分のアカウントだけを削除したい場合)',
    errorAtLeastOneCompany:
        'ユーザーアカウントは最低でも一つの会社アカウントに所属する必要があります。すべての会社アカウントの削除をご希望の場合、ユーザーアカウントも削除してください。 もし他の会社アカウントにて一般権限メンバーとして所属しており、現在所有者としてログインしている会社アカウントのみ削除したいという場合は、お手数とはなりますが右下のチャット窓口よりその旨をご連絡ください。',
    errorYouDidNotSelectAnything: '削除するものが選択されていません。',
    errorYouWantToDeleteYourAccount:
        '現在、次の企業の所有者となっております。ご自身のアカウントの削除をご希望の場合、これらの企業を削除いただくか、他のメンバーを所有者として指定し、再度削除ページまでお戻りください。',
    improvementsLabel:
        '改善点などございましたら、今後の参考にさせていただきますので、ぜひお聞かせください。',
    notificationSettings: '通知設定',
    reasonDetailLabel: '具体的に解約の背景をお聞かせください。',
    selectTheData: '削除がご希望の場合、対象のデータを下記よりお選びください。',
    selectedReasonLabel: '解約の理由を以下よりひとつお選びください。',
    selectedReasonOption1: '使用頻度・書類の発行枚数が減った',
    selectedReasonOption2: '他社製品・他システムへ移行した',
    selectedReasonOption3: '機能が不十分だった',
    selectedReasonOption4: '使い心地に満足できなかった(操作が分かりづらい等)',

    selectedReasonOption5: '料金形態が合わなかった',
    selectedReasonOption6: 'その他',
    title: '削除',
    userAccount: 'ユーザーアカウント',
    userAccountDeletionWarning:
        'ユーザーアカウントを削除すると下記の会社アカウントも削除されます。会社アカウントを残す場合は、ほかの方を所有者としてご指定ください。',
};
